import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { createI18n, I18n } from 'vue-i18n';

export const DEFAULT_LANGUAGE = HgSupportedLanguage.DE;
export enum LocaleFileSuffix {
  HG = 'hg',
}

let localeSuffix = LocaleFileSuffix.HG;

const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: DEFAULT_LANGUAGE,
  silentFallbackWarn: true,
  missing: (currentLocale: string, key: string) =>
    console.warn(`Missing translations for "${key}" in "${currentLocale}"`),
  messages: {},
});

export function initI18n(translations: any = {}, fileSuffix = LocaleFileSuffix.HG): I18n {
  // update suffix (e.g. `i18n/en-{suffix}.ts`)
  localeSuffix = fileSuffix;
  // add default messages
  i18n.global.mergeLocaleMessage(DEFAULT_LANGUAGE, translations);
  return i18n;
}

export async function safeLoadTranslations(locale: HgSupportedLanguage): Promise<void> {
  try {
    await loadTranslations(locale);
  } catch (e) {
    console.error('Could not load locales', e);
  }
}

export async function loadTranslations(locale: HgSupportedLanguage): Promise<void> {
  const loadLocale = () => import(`@/i18n/${locale}-${localeSuffix}.ts`);
  const message = (await loadLocale()).default;
  i18n.global.mergeLocaleMessage(locale, message);
}
